import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { concatMap, filter, finalize, tap } from "rxjs/operators";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { EDIT_MODE, FORM_TYPE_CHECKBOX, FORM_TYPE_FILE, FORM_TYPE_TEXT, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0 } from "../../../../../crossconcern/utilities/properties/base.property";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import { Validators } from "@angular/forms";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_DETAIL_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { of } from "rxjs";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { HttpEventType, HttpResponse } from "@angular/common/http";
var NurseryEditComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryEditComponent, _super);
    function NurseryEditComponent(appComponent, router, location, genericService, nurseryManager, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.selectedFiles = [];
        _this.mode = EDIT_MODE;
        _this.imageURL = null;
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_NAME", "name", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_ADDRESS", "address", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LAT", "latitude", [
                Validators.required,
                Validators.pattern("[0-9]+([.][0-9]+)?")
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_LONG", "longitude", [
                Validators.required,
                Validators.pattern("[0-9]+([.][0-9]+)?")
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_FILE, "NURSERY_DETAIL_COMPONENT_SPHERES", "spheres", [], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, undefined, undefined, ".jpg,.jpeg,.png", true),
            new FormInfoField(FORM_TYPE_FILE, "NURSERY_DETAIL_COMPONENT_CSV", "csv", [], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, undefined, undefined, ".csv", false),
            new FormInfoField(FORM_TYPE_TEXT, "NURSERY_DETAIL_COMPONENT_VERSION_NUMBER", "versionNumber", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_CHECKBOX, "NURSERY_DETAIL_COMPONENT_VISIBLE", "visible", [
                Validators.required
            ], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0)
        ];
        _this.formInfo = new FormInfo(formInfoFields, null);
        _this.subscribeGenericServices();
        return _this;
    }
    NurseryEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.getNursery(params.id);
        });
    };
    NurseryEditComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    NurseryEditComponent.prototype.getNursery = function (id) {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.getNursery(id).pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function (nursery) {
            _this.nursery = nursery;
            var values = {
                name: _this.nursery.name,
                address: _this.nursery.address,
                latitude: _this.nursery.latitude,
                longitude: _this.nursery.longitude,
                visible: (_this.nursery.visible === null) ? false : _this.nursery.visible,
                versionNumber: _this.nursery.versionNumber,
                spheres: null,
                csv: null
            };
            for (var _i = 0, _a = _this.formInfo.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                field.selectedValue = values[field.formControlName];
            }
            _this.formComponent.updateFormValues(_this.formInfo);
        });
    };
    NurseryEditComponent.prototype.onSaveNursery = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.editNursery(this.nursery.uuid, {
            "name": this.formComponent.form.value.name,
            "address": this.formComponent.form.value.address,
            "latitude": this.formComponent.form.value.latitude,
            "longitude": this.formComponent.form.value.longitude,
            "visible": this.formComponent.form.value.visible,
            "version_number": this.formComponent.form.value.versionNumber
        })
            .pipe(concatMap(function () { return _this.uploadImages(); }), concatMap(function () { return _this.uploadCSV(); }), finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe({
            complete: function () { return _this.goToRouteByName(PRIVATE_NURSERY_DETAIL_ROUTE, { id: _this.nursery.uuid }); }
        });
    };
    NurseryEditComponent.prototype.onFilesSelected = function (event) {
        this.selectedFiles = event;
    };
    /* eslint-disable dot-notation */
    NurseryEditComponent.prototype.uploadImages = function () {
        var _this = this;
        if (this.selectedFiles["spheres"] && this.selectedFiles["spheres"].length > 0) {
            this.showSpheresProgress("0%");
            return this.nurseryManager.addNurserySpheres(this.selectedFiles["spheres"], this.nursery.uuid)
                .pipe(tap(function (event) {
                if (event && event["type"] === HttpEventType.UploadProgress) {
                    var percentDone = Math.round(100 * event["loaded"] / event["total"]);
                    if (percentDone < 100) {
                        _this.showSpheresProgress(percentDone + "%");
                    }
                    else {
                        _this.showSpheresProgress("NURSERY_EDIT_COMPONENT_LOADING_CONNECT");
                    }
                }
            }), filter(function (event) { return event instanceof HttpResponse; }), finalize(function () { return _this.hideSpheresProgress(); }));
        }
        return of({});
    };
    NurseryEditComponent.prototype.uploadCSV = function () {
        if (this.selectedFiles["csv"] && this.selectedFiles["csv"].length > 0) {
            return this.nurseryManager.addNurseryCSV(this.selectedFiles["csv"], this.nursery.uuid);
        }
        return of({});
    };
    /* eslint-enable dot-notation */
    NurseryEditComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_DETAIL_ROUTE, { id: _this.nursery.uuid });
        });
    };
    NurseryEditComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    NurseryEditComponent.prototype.showSpheresProgress = function (text) {
        this.sphereLoadingVisible = true;
        this.currentLoading = text;
    };
    NurseryEditComponent.prototype.hideSpheresProgress = function () {
        this.sphereLoadingVisible = false;
        this.currentLoading = "0%";
    };
    return NurseryEditComponent;
}(BaseComponent));
export { NurseryEditComponent };
